/* eslint-disable indent */
import React from 'react';
import { Avatar } from '@material-ui/core';
import Icons from '../Icons/Icons.component';

const TruckInfo = ({ classes, truck }) => {
  if (truck.status === `INTRANSIT`) {
    return (
      <div className={classes.truckMarkerIconWrapper}>
        <Avatar classes={{ root: classes.truckMarkerIcon }}>
          <Icons color="#000" size="20" type="TRUCK" />
        </Avatar>
      </div>
    );
  } else if (truck.status === `LOADING`) {
    return (
      <div className={classes.truckLoadingMarkerIconWrapper}>
        <Avatar classes={{ root: classes.truckLoadingMarkerIcon }}>
          <Icons color="#fff" size="20" type="TRUCK" />
        </Avatar>
      </div>
    );
  }
};

export default TruckInfo;
